<template>
  <b-container class="home-carousel" fluid>
    <div :class="[titleIcon ? 'banner-img  banner-img-product' : 'banner-img']">
      <img :src="src" alt="banner" />
      <div class="banner-text" v-if="titleIcon">
        <!-- <h2 class="banner-header">''</h2> -->
        <h1>{{ title }}</h1>
        <h1>{{ titleSecond }}</h1>
        <p>{{ text }}</p>
      </div>
      <div class="banner-text" v-if="!titleIcon && !video">
        <h1>{{ title }}</h1>
        <p>{{ text }}</p>
        <p>{{ textTwo }}</p>
      </div>
      <div class="banner-text banner-video container" v-if="video">
        <h1>{{ title }}</h1>
        <p>{{ text }}</p>
        <b-button variant="primary" class="video-button" @click="link">
          入汇吧
          <b-icon-arrow-right></b-icon-arrow-right>
        </b-button>
      </div>
    </div>
  </b-container>
</template>
<script>
export default {
  name: "banners",
  data() {
    return {
      actives: false
    };
  },
  // watch: {
  //   $route: "headerChange"
  // },
  props: {
    src: {
      type: String
    },
    title: {
      type: String
    },
    video: {
      type: Boolean,
      default: false
    },
    titleSecond: {
      type: String
    },
    text: {
      type: String
    },
    textTwo: {
      type: String
    },
    titleIcon: {
      type: Boolean,
      default: false
    },
    link: {
      type: Function
    }
  },
  method: {
    headerChange() {
      const routers = this.$route.path;
      if (routers.indexOf("product") > -1) {
        this.actives = true;
      } else {
        this.actives = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.home-carousel {
  padding: 0;
}
</style>
